////////////////////////////////////////////////
/////////////// Event Delegation ///////////////
////////////////////////////////////////////////
export const addEventDelegation = (bindSelector, eventSelector, eventType, functionCode) => {
    const bindElements = document.querySelectorAll(bindSelector);
    bindElements.forEach((bindElement) => {
        bindElement.addEventListener(eventType, (event) => {
            // Check event delegation: https://javascript.info/event-delegation
            const eventElement = event.target.closest(eventSelector);
            if (!eventElement) return;
            if (!bindElement.contains(eventElement)) return;
            functionCode(eventElement, event);
        });
    });
};

////////////////////////////////////////////////
///////////////// HTML Escape //////////////////
////////////////////////////////////////////////
export const htmlEscape = (str) => {
    // https://www.w3docs.com/snippets/javascript/how-to-html-encode-a-string.html
    return str.replace(/&/g, "&amp").replace(/'/g, "&apos").replace(/"/g, "&quot").replace(/>/g, "&gt").replace(/</g, "&lt");
};

////////////////////////////////////////////////
//////////////// Primary Navigation ////////////
////////////////////////////////////////////////

(function () {
    const primaryNavigation = document.querySelector(".primary-navigation");

    window.addEventListener("keydown", (e) => {
        if (e.key === "Escape" || e.key === "Esc") {
            primaryNavigation.setAttribute("hidden", "true");
        }
    });
})();

////////////////////////
// Primary Navigation Accordion ///////////
///////////////////////

(function () {
    const headers = document.querySelectorAll("[data-accordion-header]");

    const toggleHeader = (header, target, hide) => {
        if (typeof hide === "undefined") {
            hide = header.getAttribute("aria-expanded") === "true" || false;
        }
        header.setAttribute("aria-expanded", !hide);
        if (header.getAttribute("data-accordion-header") === "alternate") {
            target.setAttribute("data-expanded", !hide);
        } else {
            target.hidden = hide;
        }
    };

    const getTarget = (header) => {
        const identifier = header.getAttribute("aria-controls") || header.id;
        return document.querySelector(`[aria-labelledby="${identifier}"]`);
    };

    headers.forEach((header) => {
        let target = getTarget(header);

        header.addEventListener("click", (event) => {
            event.preventDefault();

            if (header.getAttribute("data-accordion-set")) {
                const set = header.getAttribute("data-accordion-set");
                headers.forEach((other) => {
                    if (other.getAttribute("data-accordion-set") === set) {
                        target = getTarget(other);
                        if (header !== other) {
                            toggleHeader(other, target, true);
                        } else {
                            toggleHeader(header, target);
                        }
                    }
                });
            } else if (header.getAttribute("data-accordion-unique") !== "false") {
                headers.forEach((other) => {
                    target = getTarget(other);
                    if (header !== other) {
                        toggleHeader(other, target, true);
                    } else {
                        toggleHeader(header, target);
                    }
                });
            } else {
                toggleHeader(header, target);
                header.classList.remove("active");
            }
        });
    });
})();

////////////////////////////////////////////////
//////////////// Arrow disapperance //////////////
////////////////////////////////////////////////
const banner = document.querySelector(".banner");
const header = document.querySelector(".header");
const arrow = document.querySelector(".arrow");

const obsOptions = {
    root: null,
    rootMargin: "-50px",
    threshold: 0,
};

function showArrow(entries) {
    entries.forEach((entry) => {
        if (!entry.isIntersecting) {
            arrow.classList.add("hidden");
        } else {
            arrow.classList.remove("hidden");
        }
    });
}
try {
    if (arrow) {
        if (banner !== null) {
            let observer = new IntersectionObserver(showArrow, obsOptions);
            observer.observe(banner);
        } else if (header !== null) {
            let observer = new IntersectionObserver(showArrow, obsOptions);
            observer.observe(header);
        }
    }
} catch (error) {
    console.log(error);
}

//////////////////////////////////////////////////
////////////// Back to top Arrow  ////////////////
//////////////////////////////////////////////////
const arrowUp = document.querySelector(".arrow-up");
const footer = document.querySelector(".footer");

const backToTop = {
    root: null,
    rootMargin: "0px",
    threshold: 0,
};

function showArrowUp(entries) {
    entries.forEach((entry) => {
        if (!entry.isIntersecting) {
            arrowUp.classList.add("hidden");
        } else {
            arrowUp.classList.remove("hidden");
        }
    });
}
try {
    if (arrowUp) {
        if (footer !== null) {
            let observer = new IntersectionObserver(showArrowUp, backToTop);
            observer.observe(footer);
        }
    }
} catch (error) {
    console.log(error);
}

////////////////////////////////////////////////////////
/////////////////// Cookie Policy //////////////////////
////////////////////////////////////////////////////////

(function () {
    let cookieModal = document.querySelector(".cookie-policy");
    let acceptBtn = document.querySelector(".button-accept");

    if (acceptBtn && cookieModal) {
        acceptBtn.addEventListener("click", () => {
            hideCookiePolicyPopup();
            setCookiePolicy("1");
        });

        function hideCookiePolicyPopup() {
            cookieModal.classList.add("cookie-policy--hidden");
            cookieModal.setAttribute("aria-hidden", "true");
        }

        if (document.cookie.indexOf("ck_pref") == -1) {
            cookieModal.classList.remove("cookie-policy--hidden");
            cookieModal.setAttribute("aria-hidden", "false");
        }

        if (document.cookie.indexOf("ck_pref") != -1) {
            hideCookiePolicyPopup();
        }

        function setCookiePolicy(preference) {
            // Get cookie expiry date (current date + 1 year)
            var date = new Date(Date.now());
            var year = date.getFullYear();
            year++;
            date.setFullYear(year);
            date = date.toUTCString();
            // Set cookie
            document.cookie = "ck_pref=" + preference + "; path=/; expires=" + date;
            console.log(document.cookie);
        }

        function optOutCookiePolicy() {
            // Update cookie preference
            setCookiePolicy("0");
            // Delete non-required cookies
            var deleteCookieArray = [
                // optional cookie information to go here
                // ['_ga', '.site.com'],
                // ['_gid', '.site.com'],
                // ['_dc_gtm_UA-60999944-1', '.site.com'],
                // ['_hjid', '.site.com'],
                // ['_hjIncludedInSample', '']
            ];
            for (var i = 0; i < deleteCookieArray.length; i++) {
                document.cookie = deleteCookieArray[i][0] + "=; domain=" + deleteCookieArray[i][1] + "; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
            }
            // If GTM has been loaded, refresh the page
            if (typeof dataLayer === "object") {
                location.reload();
            }
        }

        // Process the users action when toggling the cookie switch
        let cookieSwitchId = document.querySelector("#cookie-switch");
        let cookieSwitchClass = document.querySelector(".cookie-switch");
        if (cookieSwitchId) {
            if (document.cookie.match("ck_pref=1")) {
                cookieSwitchId.checked = true;
            } else {
                cookieSwitchId.checked = false;
            }

            cookieSwitchId.addEventListener("change", function () {
                hideCookiePolicyPopup();
                if (cookieSwitchId.checked) {
                    setCookiePolicy("1");
                } else {
                    optOutCookiePolicy();
                }
            });

            cookieSwitchClass.addEventListener("keyup", function (e) {
                hideCookiePolicyPopup();
                if (e.keyCode === 13) {
                    if (document.querySelector(this).querySelector("input").checked) {
                        cookieSwitchId.checked = false;
                        optOutCookiePolicy();
                    } else {
                        cookieSwitchId.checked = true;
                        setCookiePolicy("1");
                    }
                }
            });
        }
    }
})();

//////////////////////////////////////////////////////////////////
/////////////////// Add Wrapper before Tabs //////////////////////
//////////////////////////////////////////////////////////////////
document.addEventListener("DOMContentLoaded", function () {
    let contentWrappers = document.querySelectorAll(".content, .wysiwyg-content");
    for (let j = 0; j < contentWrappers.length; j++) {
        let tables = contentWrappers[j].getElementsByTagName("table");
        for (let i = 0; i < tables.length; i++) {
            let wrappedDiv = document.createElement("div");
            wrappedDiv.classList.add("responsive-table");
            tables[i].parentNode.insertBefore(wrappedDiv, tables[i]);
            wrappedDiv.appendChild(tables[i]);
        }
    }
});

//////////////////////////////////////////////////////////////////
//////// Climate Friendly Switch + Personalisation Banner ////////
//////////////////////////////////////////////////////////////////
document.addEventListener("DOMContentLoaded", function () {
    const checkbox1 = document.getElementById("climate-friendly-checkbox1");
    const checkbox2 = document.getElementById("climate-friendly-checkbox2");
    const switches = [checkbox1, checkbox2];

    if (checkbox1 && checkbox2) {
        switches.forEach((checkbox) => {
            checkbox.addEventListener("change", () => {
                toggleCookie();
                location.reload();
            });
        });
    }

    // Code related to layer1
    const layer1 = document.getElementById("layer1");
    if (layer1) {
        const cookieName = "layer1_displayed";
        const cookieValue = "true";
        const cookieExpires = 365;

        // Check if the cookie is set
        if (getCookie(cookieName)) {
            // Cookie is set, hide the popup
            layer1.style.display = "none";
        } else {
            // Cookie is not set, show the popup
            layer1.style.display = "block";
            // Set the cookie to indicate that the popup has been displayed
            setCookie(cookieName, cookieValue, cookieExpires);
        }

        const closeButton = document.getElementById("closebtn");
        const normalButton = document.getElementById("climate-friendly-button1");
        const climateButton = document.getElementById("climate-friendly-button2");

        document.body.addEventListener("click", (event) => {
            if (event.target !== normalButton && event.target !== closeButton) {
                return;
            }
            layer1.style.display = "none";
        });
        climateButton.addEventListener("click", () => {
            toggleCookie();
            location.reload();
        });

        document.querySelector(".personalisation").addEventListener("click", function (event) {
            // Check if the clicked element is the parent div
            if (event.target === this) {
                // Hide the parent div
                layer1.style.display = "none";
                // this.style.display = "none";
            }
        });
    }

    function toggleCookie() {
        const cookieName = "climate_friendly";
        const cookieValue = "true";

        if (getCookie(cookieName)) {
            removeCookie(cookieName);
        } else {
            setCookie(cookieName, cookieValue, 365);
        }
    }

    function setCookie(name, value, days) {
        const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `${name}=${value}; expires=${expires}; path=/`;
    }

    function getCookie(name) {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            const [cookieName, cookieValue] = cookie.split("=");
            if (cookieName === name) {
                return cookieValue;
            }
        }
        return null;
    }

    function removeCookie(name) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
});

///////////////////////////////////////////////////////
//////////////// Clear Search and X button ////////////
///////////////////////////////////////////////////////

(function () {
    // get all input elements with type="search"
    const searchInputs = document.querySelectorAll('input[type="search"]');
    if (!searchInputs) return;
    searchInputs.forEach((input) => {
        const clearLink = document.createElement("div");
        clearLink.className = "clear";
        clearLink.setAttribute("aria-label", "Close Search");
        clearLink.style.display = "none";
        input.insertAdjacentElement("afterend", clearLink);
        input.addEventListener("input", function () {
            if (input.value.length > 0) {
                clearLink.style.display = "block";
            } else {
                clearLink.style.display = "none";
            }
        });
        clearLink.addEventListener("click", function (event) {
            event.preventDefault();
            input.value = "";
            clearLink.style.display = "none";
            input.focus();
        });
    });
})();

//////////////////////////////////////////////////
////////////////// Modals JS  ////////////////////
//////////////////////////////////////////////////
(function () {
    // const openButtons = document.querySelectorAll(".button-open, button[data-dialog]");

    const addFocusTrap = (e) => {
        if (e.key === "Tab") {
            e.preventDefault();
        }
    };
    const closeModalOnOutsideClick = (event) => {
        const modalContent = event.currentTarget.querySelector(".side-container__modal-content");
        if (modalContent && event.target !== modalContent && !modalContent.contains(event.target)) {
            event.currentTarget.close();
            event.currentTarget.removeEventListener("keydown", addFocusTrap);
        }
    };
    const dialogOpenButtons = (button) => {
        const dialog = button.getAttribute("data-dialog");
        let modal = document.querySelector(`dialog[data-dialog="${dialog}"]`);
        if (!modal) {
            modal = button.parentElement.nextElementSibling;
        }
        if (modal) {
            modal.showModal();
            modal.querySelector(".button-close-modal").focus();
            modal.addEventListener("keydown", addFocusTrap);
            modal.addEventListener("click", closeModalOnOutsideClick);
        }
    };
    addEventDelegation("body", ".button-open, button[data-dialog]", "click", dialogOpenButtons);

    const closeButtons = document.querySelectorAll(".button-close-modal");
    if (!closeButtons) return;

    closeButtons.forEach((button) => {
        button.addEventListener("click", () => {
            const modal = button.closest("dialog");
            modal.close();
        });
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            const openModal = document.querySelector("dialog[open]");
            if (openModal) {
                openModal.close();
                openModal.removeEventListener("keydown", addFocusTrap);
                openModal.removeEventListener("click", closeModalOnOutsideClick);
            }
        }
    });
    const searchAddressButtonQas = document.getElementById("searchAddressButtonQas");
    if (searchAddressButtonQas) {
        const searchAddressModalQas = document.getElementById("searchAddressModalQas");
        searchAddressButtonQas.addEventListener("click", () => {
            searchAddressModalQas.showModal();
        });
    }
    const searchAddressButtonBfo = document.getElementById("searchAddressButtonBfo");
    if (searchAddressButtonBfo) {
        const searchAddressModalBfo = document.getElementById("searchAddressModalBfo");
        searchAddressButtonBfo.addEventListener("click", () => {
            searchAddressModalBfo.showModal();
        });
    }
    const ecSearchAddressButtonQas = document.getElementById("ecSearchAddressButtonQas");
    if (ecSearchAddressButtonQas) {
        const ecSearchAddressModalQas = document.getElementById("ecSearchAddressModalQas");
        ecSearchAddressButtonQas.addEventListener("click", () => {
            ecSearchAddressModalQas.showModal();
        });
    }
    const ecSearchAddressButtonBfo = document.getElementById("ecSearchAddressButtonBfo");
    if (ecSearchAddressButtonBfo) {
        const ecSearchAddressModalBfo = document.getElementById("ecSearchAddressModalBfo");
        ecSearchAddressButtonBfo.addEventListener("click", () => {
            ecSearchAddressModalBfo.showModal();
        });
    }
})();

//////////////////////////////////////////////////
//////////////// Form Validation /////////////////
//////////////////////////////////////////////////
// https://gitlab.squiz.net/marketplace/internal/matrix-simple-form-validation/-/tree/master
// Modified by John McCormick 2023

// Notes:
// Each question inc. label and field(s) should be wrapped with a class called .sq-form-question
// aria-described is being added and removed for error messaging accessibility purposes

export function simpleFormValidation(form, submit, customValidation) {
    const formElements = form.elements;

    // Keep track of which fields have been checked
    // So that don't need to loop through each radio/checkbox in a group
    let checkedFields = [];

    // To focus on when validation check has finished for accessibility reasons
    let focusErrorField;

    // Remove all existing errors
    // Loop through each question group with this error class
    form.querySelectorAll(".sq-form-question-error").forEach((questionGroup) => {
        // Remove question group error class
        questionGroup.classList.remove("sq-form-question-error");

        // Remove aria-describedby attribute applied on fields within the group
        // Loop through checkboxes / radios
        questionGroup.querySelectorAll("[aria-describedby]").forEach((elField) => {
            elField.removeAttribute("aria-describedby");
        });

        // Remove error message element
        let elErrorMessage = questionGroup.querySelector(".sq-form-error");

        if (elErrorMessage) {
            elErrorMessage.remove();
        }
    });

    // Perform validation
    // Loop through each of this form's elements
    for (let i = 0, j = formElements.length; i < j; ++i) {
        let isValidated = false;

        let formElement = formElements[i];

        let formElementName = formElement.name;

        // Selector needs colons (which exist in Matrix field names) to be escaped
        let escapedFormElementName = formElementName.replaceAll(/(:|\[|\])/g, "\\$1");

        // If this field name doesn't exist in the array of validated
        // It means we haven't checked this field name / group yet
        if (checkedFields.indexOf(formElementName) === -1) {
            let formElementType = formElement.type;

            let errorMessage = "";
            if (formElementName === "" || formElement.disabled || formElementType === "submit" || formElementType === "hidden" || formElement.closest(".hide") || (!submit && !formElement.hasAttribute("data-has-error"))) {
                // Skip the undefined, disabled elements, submit button and hidden fields
                continue;
            }

            form.querySelectorAll(`[name=${escapedFormElementName}]`).forEach((formElement) => {
                formElement.removeAttribute("data-has-error");
            });

            switch (formElementType) {
                case "text":
                case "email":
                case "tel":
                case "date":
                case "number":
                case "url":
                case "color":
                case "date":
                case "datetime-local":
                case "textarea":
                case "select-one":
                case "select-multiple":
                case "range":
                case "file":
                    if (formElement.checkValidity()) {
                        // Edit made by John to add dynamic custom validation
                        if (customValidation) {
                            errorMessage = customValidation(formElement);
                            isValidated = errorMessage === "" ? true : false;
                        } else {
                            isValidated = true;
                        }
                    } else {
                        errorMessage = formElement.validationMessage;
                    }

                    // Edit made by John to add dynamic custom validation (this condition moved and modified)
                    if (!isValidated && !focusErrorField) {
                        focusErrorField = formElement;
                    }

                    break;

                case "radio":
                case "checkbox":
                    // Get all the input fields of this group
                    let elInputFields = form.querySelectorAll(`input[name=${escapedFormElementName}]`);

                    // Loop through each one
                    for (let i = 0, j = elInputFields.length; i < j; ++i) {
                        let inputField = elInputFields[i];

                        // If this one passes validity,
                        if (inputField.checkValidity()) {
                            // Edit made by John to add dynamic custom validation
                            if (customValidation) {
                                errorMessage = customValidation(inputField);
                                isValidated = errorMessage === "" ? true : false;
                            } else {
                                // Update validation flag
                                isValidated = true;
                            }
                        } else {
                            if (inputField.type === "checkbox" && inputField.validity.valueMissing) {
                                // Assuming that if all checkboxes are marked as required
                                // And Only one needs to be checked
                                // Specify unique error msg instead of default
                                // e.g. "Please tick this box to continue"
                                errorMessage = "Please select one of these options";
                            } else {
                                // Use default
                                errorMessage = inputField.validationMessage;
                            }
                        }
                        // Edit made by John to add dynamic custom validation (break was moved into this condition from above)
                        if (isValidated || errorMessage) {
                            // Don't need to check the rest
                            break;
                        }
                    }

                    // If all checkboxes/radios didn't pass validation
                    // And no focus error field is set yet
                    if (!isValidated && !focusErrorField) {
                        // Make the first field focused
                        for (let i = 0; i < elInputFields.length; i++) {
                            if (!elInputFields[i].disabled) {
                                focusErrorField = elInputFields[i];
                                break;
                            }
                        }
                    }
                    break;
            }

            if (formElement.value.includes("@@") && formElementType === "email") {
                errorMessage = "Invalid email address, it contains too many @ symbols";
            }
            // If validation has failed for this field
            // Add error message
            if (!isValidated) {
                // Create the errpr message element
                let errorMsgElement = document.createElement("p");

                // Construct id of error message element
                let errorElementID = formElementName + "__error";

                // Add id so that aria-describedby applied on fields will point to error message
                errorMsgElement.setAttribute("id", errorElementID);

                // Add class for styling
                errorMsgElement.classList.add("sq-form-error");

                // Add the error message text into the error message element
                errorMsgElement.innerHTML = errorMessage;

                // Add error message element in to form question group
                formElement.closest(".sq-form-question").appendChild(errorMsgElement);

                // querySelectorAll used to add this attribute to all related radios and checkboxes
                form.querySelectorAll(`[name=${escapedFormElementName}]`).forEach((formElement) => {
                    formElement.setAttribute("aria-describedby", errorElementID);
                    formElement.setAttribute("data-has-error", "");
                });

                // Add error class to form question group for styling
                formElement.closest(".sq-form-question").classList.add("sq-form-question-error");
            }

            checkedFields.push(formElementName);
        }
    }

    // Validatin has finished.
    // What's the outcome and action from this?
    if (!focusErrorField || !submit) {
        return true;
    } else {
        // On rare occasions focus() doesn't work properly; setTimeout added in an attempt to improve this
        window.setTimeout(() => focusErrorField.focus(), 100);
        return false;
    }
}
